import React from 'react';

import Button from '@material-ui/core/Button';
import ButtonBase from '@material-ui/core/ButtonBase';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import KeyboardReturnIcon from '@material-ui/icons/KeyboardReturn';
const stylesBt = theme => ({
    button: {
        margin: theme.spacing.unit,
        position: 'fixed',
        bottom: theme.spacing.unit * 2,
        right: theme.spacing.unit * 2,
    },
});

class Numpad extends React.Component {
    state = {

    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    };

    handleClose = value => {
        this.setState({ open: false });
    };

    render() {
        const { classes, width } = this.props;
        let bWidth = width/3-5;
        let fLarge = width * 0.125;
        let fTitle = width * 0.04;
        return (
            <div style={{width,zIndex:9999,padding:5,textAlign:'center',backgroundColor:"black",color:'white',fontSize:'1.4rem'}}>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth/1.9}}>
                    <Grid item xs={4} >
                    <ButtonBase  onClick={()=>this.props.handleClick("1")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                            <span className="comp_text_gradient" style={{fontSize:fLarge}}>1</span>
                            </ButtonBase>
                    </Grid>
                    <Grid item xs={4} >
                    <ButtonBase  onClick={()=>this.props.handleClick("2")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                            <span className="comp_text_gradient" style={{fontSize:fLarge}}>2</span>
                            </ButtonBase>
                    </Grid>
                    <Grid item xs={4} >
                    <ButtonBase  onClick={()=>this.props.handleClick("3")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                            <span className="comp_text_gradient" style={{fontSize:fLarge}}>3</span>
                            </ButtonBase>
                    </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth/1.9}}>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("4")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>4</span>
                          </ButtonBase>
                  </Grid>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("5")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>5</span>
                          </ButtonBase>
                  </Grid>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("6")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>6</span>
                          </ButtonBase>
                  </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth/1.9}}>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("7")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>7</span>
                          </ButtonBase>
                  </Grid>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("8")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>8</span>
                          </ButtonBase>
                  </Grid>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("9")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>9</span>
                          </ButtonBase>
                  </Grid>
                </Grid>
                <Grid container direction="row" alignItems="center" justify="center" style={{width:"100%",height:bWidth/1.9}}>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("0")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>0</span>
                          </ButtonBase>
                  </Grid>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("-1")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>X</span>
                          </ButtonBase>
                  </Grid>
                  <Grid item xs={4} >
                  <ButtonBase  onClick={()=>this.props.handleClick("Enter")} style={{backgroundImage:'url(/assets/comp/button.png)',backgroundSize:'100% 100%',color:"#538234",padding:0,minWidth:0,fontSize:"1.5rem",width:bWidth,height:bWidth/2}} color="secondary"  variant="contained"  >
                          <span className="comp_text_gradient" style={{fontSize:fLarge}}>⇒</span>
                          </ButtonBase>
                  </Grid>

                </Grid>
            </div>
        );
    }
}

Numpad.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(stylesBt)(Numpad);
